import { useEventDataOfSelectedEvent } from "@Utils";
import { useEffect, useState } from "react";
import { URL_SEARCH_PARAMS } from "repoV2/constants/urls&routing/urlParams";
import { logError } from "repoV2/utils/common/error/error";
import { getQueryParam } from "repoV2/utils/urls&routing/urlParams";
import { IInstalment } from "../IPaymentPlan";
import { callGetInstalmentsDetails } from "../api/apiCalls";

const useInstalmentsDetails = () => {
    const {
        eventData: { uuid },
    } = useEventDataOfSelectedEvent();

    const [instalments, setInstalments] = useState<IInstalment[]>([]);
    const [loading, setLoading] = useState(false);

    const isDiscountAppliedOnInstallments = instalments?.some(
        installment => installment.discount_applied
    );
    const hasInstallments = instalments.some(
        instalment => instalment.installment_price_final
    );
    const dynamicLink = getQueryParam(URL_SEARCH_PARAMS.DYNAMIC_LINK);
    const shouldFetchInstalments = !dynamicLink; // not showing instalments plan for dynamic links

    const handleFetchInstalmentsDetails = async (
        payload?: {
            currency?: string;
            discountCode?: string;
            appliedCount?: number;
        },
        onSuccess?: () => void
    ) => {
        try {
            setLoading(true);
            const responseInstalments = await callGetInstalmentsDetails({
                listingUuid: uuid,
                ...payload,
            });
            setInstalments(responseInstalments);
            if (onSuccess) onSuccess();
        } catch (error) {
            logError({
                error,
                occuredAt:
                    "src/components/eventPage/components/PaymentPlan/hooks/useInstalmentsDetails.ts",
                when: "calling handleFetchInstalmentsDetails",
            });
        } finally {
            setLoading(false);
        }
    };

    const handleApplyDiscountOnInstallments = (
        payload: {
            currency?: string;
            discountCode?: string;
            appliedCount?: number;
        },
        onSuccess?: () => void
    ) => {
        handleFetchInstalmentsDetails(payload, onSuccess);
    };

    useEffect(() => {
        if (uuid && shouldFetchInstalments) handleFetchInstalmentsDetails();
    }, [uuid]);

    return {
        showInstallmentsPlan: shouldFetchInstalments && hasInstallments,
        loading,
        instalments,
        isDiscountAppliedOnInstallments,
        handleApplyDiscountOnInstallments,
        refetchInstallments: handleFetchInstalmentsDetails,
    };
};

export default useInstalmentsDetails;
